module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-fill-c06d5871.svg";